export default __webpack_public_path__ + "static/media/55.7878cce7.png";